document.addEventListener("DOMContentLoaded", (event) => {
    console.log("Registered message listener");
    window.addEventListener('message', e => {
        const key = e.message ? 'message' : 'data';
        const data = e[key];

        if(data.name && data.name==="authRedirect") {
            var redirectLocation = data.value;
            document.getElementById("portal-auth-container").remove()
            window.location = redirectLocation;
        }
    },false);
});